import FormControl from "common/components/FormControl/FormControl";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { AppointmentType } from "types";
import { buildDurationOptions } from "utils/duration";
// import ContactTypeSelect from "components/select/ContactTypeSelect/ContactTypeSelect";
import ColorSelect from "components/select/ColorSelect/ColorSelect";
import CrudForm from "common/components/Crud/CrudForm";

type Props = {
  onSubmit: (values: any) => any;
  onCancel?: () => void;
  item?: AppointmentType;
};

function AppointmentTypeForm({ onSubmit, onCancel, item }: Props) {
  const { t } = useTranslation();

  const initialValues = useMemo(
    () =>
      item?.id
        ? {
            ...item,
          }
        : {},
    [item]
  );

  const durationOptions = useMemo(() => buildDurationOptions(8 * 60, 15), []);

  return (
    <CrudForm
      onSubmit={onSubmit}
      onCancel={onCancel}
      initialValues={initialValues}
      headerIcon="WrenchScrewdriverIcon"
      i18nNamespace="appointment-types"
      render={() => (
        <div className="flex flex-row gap-4 white-box">
          <div className="flex flex-col w-full gap-2">
            <FormControl
              name="name"
              title={t("appointment-types.name")}
              required
            />
            <FormControl
              name="duration"
              title={t("appointment-types.duration")}
              type="select"
              options={durationOptions}
              containerStyle="w-full sm:w-1/2"
            />
            <div className="flex flex-row gap-10 w-full">
              <FormControl
                name="color"
                title={t("appointment-types.color")}
                type="custom"
                containerStyle="w-full sm:w-3/4 md:w-2/3 lg:w-2/3"
              >
                <ColorSelect />
              </FormControl>
              <FormControl
                name="iconName"
                title={t("appointment-types.icon")}
                type="select-icon"
                className="self-start"
              />
            </div>
          </div>
        </div>
      )}
    />
  );
}

export default AppointmentTypeForm;
